import { useMemo } from "react"
import { useMeContext } from "@/model/user/provider"
import { isSubscriptionValid } from "@/model/user/me"

export const useUserSubscriptionStatus = () => {
  const { me } = useMeContext()

  const subscriptionStatus = useMemo(
    () => ({
      isPro: me.isPro,
      proDate: me.userInfo.info.permissions?.proUntil,
      coachDate: me.userInfo.info.permissions?.coachPaidUntil,
      isCoachPaid: isSubscriptionValid(me.userInfo.info.permissions?.coachPaidUntil ?? undefined),
    }),
    [me],
  )

  return subscriptionStatus
}
